import React, { useState } from 'react';
import { Button, Box, LinearProgress, Typography } from '@mui/material';
import CloudUpload from '@material-ui/icons/CloudUpload';
import { styled } from '@mui/material/styles';
import { uploadFile } from '../../helpers';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const MAX_LOCAL_VIDEO_SIZE_MB = 250;

export default function VideoUploadButton({ profileId, videos, setVideos }) {
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState('');

  const handleFileUpload = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = '';

    if (!file || !profileId) return;

    if (!file.type?.startsWith('video/')) {
      setMessage('Vyberte video súbor.');
      return;
    }

    if (file.size > MAX_LOCAL_VIDEO_SIZE_MB * 1024 * 1024) {
      setMessage(`Video je príliš veľké. Maximálna veľkosť uploadu je ${MAX_LOCAL_VIDEO_SIZE_MB} MB.`);
      return;
    }

    setUploading(true);
    setProgress(0);
    setMessage('Video sa nahráva a optimalizuje. Pri väčšom videu to môže chvíľu trvať.');

    uploadFile(
      file,
      (response) => {
        setUploading(false);
        setProgress(100);

        let json;
        try {
          json = JSON.parse(response);
        } catch (error) {
          setMessage('Server vrátil neplatnú odpoveď.');
          return;
        }

        if (json?.error) {
          setMessage(json.error);
          return;
        }

        setVideos({ videos: [...(videos || []), json] });
        setMessage('Video bolo nahraté a optimalizované.');
      },
      `videos?profileId=${profileId}`,
      (percent) => {
        if (typeof percent === 'number') {
          setProgress(percent);
        }
      },
      (errorMessage) => {
        setUploading(false);
        setMessage(errorMessage || 'Upload videa zlyhal.');
      }
    );
  };

  return (
    <Box sx={{ mt: 2, width: '100%' }}>
      <Button
        component="label"
        variant="contained"
        tabIndex={-1}
        startIcon={<CloudUpload />}
        disabled={uploading || !profileId}
        sx={{ color: 'white', minHeight: 48, px: 3, fontWeight: 800, borderRadius: 2, background: '#4866c9' }}
      >
        Pridať video
        <VisuallyHiddenInput type="file" accept="video/*" onChange={handleFileUpload} />
      </Button>
      {uploading && <LinearProgress variant={progress ? 'determinate' : 'indeterminate'} value={progress} sx={{ mt: 2, borderRadius: 999, height: 8 }} />}
      {message && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1, textAlign: 'center' }}>
          {message}
        </Typography>
      )}
    </Box>
  );
}
